import CaseFeedback from './CaseFeedback';

export default CaseFeedback;
export { CaseFeedback };
